// extracted by mini-css-extract-plugin
export default {"menu":"ActionsPopup_menu__aI0E9","menuItem":"ActionsPopup_menuItem__t-mEk"};